import type { CSSProperties, FunctionComponent } from 'react';

import { token } from '@trello/theme';

interface SkeletonComponentProps {
  width: number;
  circle?: boolean;
}

export const SkeletonComponent: FunctionComponent<SkeletonComponentProps> = ({
  width,
  circle = false,
}) => {
  const styles: CSSProperties = {
    height: 32,
    width,
    borderRadius: token('border.radius.100', '3px'),
    backgroundColor: token(
      'color.background.accent.gray.subtle',
      'hsla(0, 0%, 100%, 0.3)',
    ),
  };

  if (circle) {
    styles.borderRadius = token('border.radius.circle', '50%');
  }

  return <div style={styles} />;
};
